// utils/time.js

// Format to backend format: "20250724T152000Z"
export const toBackendRTSPFormat = (unixSeconds) => {
  const date = new Date(unixSeconds * 1000);
  return date.toISOString().replace(/[-:.]/g, "").slice(0, 15) + "Z";
};

// Optional: readable HH:mm for UI
export const formatClockTime = (unixSeconds) => {
  const date = new Date(unixSeconds * 1000);
  return `${date.getHours().toString().padStart(2, "0")}:${date
    .getMinutes()
    .toString()
    .padStart(2, "0")}`;
};

// Optional: HH:mm:ss for tooltip
export const formatDuration = (seconds) => {
  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor(((seconds % 3600) % 3600) / 60);
  const secs = seconds % 60;
  return [hrs, mins, secs].map((n) => n.toString().padStart(2, "0")).join(":");
};

// export const parseBackendTimestamp = (ts) => {
//   // Input:  '20250723T090100Z'
//   // Output: Date object
//   const iso = ts.replace(/^(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2})Z$/, "$1-$2-$3T$4:$5:$6Z");
//   return new Date(iso);
// };

export const parseBackendTimestamp = (ts) => {
  // Parse the compact ISO to real UTC date
  const iso = ts.replace(/^(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2})Z$/, "$1-$2-$3T$4:$5:$6Z");
  const utcDate = new Date(iso);

  // Offset in milliseconds for IST (UTC+5:30)
  const IST_OFFSET_MS = 5.5 * 60 * 60 * 1000;

  // Apply offset manually
  const istTime = new Date(utcDate.getTime() - IST_OFFSET_MS);

  // Return Unix time in seconds
  return Math.floor(istTime.getTime() / 1000);
};

export const getBackendWindowFromUnix = (unix) => {
  return {
    startDate: toBackendRTSPFormat(unix),
    endDate: toBackendRTSPFormat(unix + 6 * 3600), // +6 hours
  };
};

export function toIsoUtcString(unixSeconds) {
  return new Date(unixSeconds * 1000).toISOString(); // Always ends with Z
}

export const formatLocalToRTSP = (date) => {
  const pad = (n) => n.toString().padStart(2, "0");
  return `${date.getFullYear()}${pad(date.getMonth() + 1)}${pad(date.getDate())}T${pad(
    date.getHours()
  )}${pad(date.getMinutes())}${pad(date.getSeconds())}Z`;
};

export const formatUnixToRTSP = (unixSeconds) => {
  const date = new Date(unixSeconds * 1000);
  const pad = (n) => n.toString().padStart(2, "0");
  return `${date.getFullYear()}${pad(date.getMonth() + 1)}${pad(date.getDate())}T${pad(
    date.getHours()
  )}${pad(date.getMinutes())}${pad(date.getSeconds())}Z`;
};

export function formatToLocalISO(timestamp) {
  const date = new Date(timestamp * 1000);

  // Convert to local time (IST in this case)
  const localDate = new Date(date.toLocaleString("en-US", { timeZone: "Asia/Kolkata" }));

  const pad = (num) => String(num).padStart(2, "0");

  const year = localDate.getFullYear();
  const month = pad(localDate.getMonth() + 1);
  const day = pad(localDate.getDate());
  const hours = pad(localDate.getHours());
  const minutes = pad(localDate.getMinutes());
  const seconds = pad(localDate.getSeconds());

  return `${year}${month}${day}T${hours}${minutes}${seconds}Z`;
}

// export function formatUnixToReadable(
//   unixSec,
//   {
//     locale = "en-GB",
//     timeZone = "Asia/Kolkata",
//     formatOptions = {
//       year: "numeric",
//       month: "2-digit",
//       day: "2-digit",
//       hour: "2-digit",
//       minute: "2-digit",
//       second: "2-digit",
//       hour12: false,
//     },
//   } = {}
// ) {
//   const date = new Date(unixSec * 1000);
//   return new Intl.DateTimeFormat(locale, {
//     timeZone,
//     ...formatOptions,
//   }).format(date);
// }

export function formatUnixToReadable(
  unixSec,
  {
    locale = "en-GB",
    formatOptions = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    },
  } = {}
) {
  const date = new Date(unixSec * 1000);
  const localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return new Intl.DateTimeFormat(locale, {
    timeZone: localTimeZone,
    ...formatOptions,
  }).format(date);
}
